import React, { PureComponent } from 'react';
import AutoSuggest from 'react-autosuggest';
import { debounce, identity } from 'lodash/fp';
import { Icon } from 'ui';
import request from 'utils/request_ajax';

/**
 * A debounced wrapper component around react-autosuggest that fetch suggestion
 * remotely via ajax.
 */

class RemoteAutoComplete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { suggestions: [], query: '', currentRequest: null };
    this.onDebouncedFetchRequested = debounce(props.wait)(
      this.onSuggestionFetchRequested,
    );
  }

  static defaultProps = {
    wait: 250,
    queryParam: 'query',
    mapResponseToSuggestions: identity,
    onSuggestionSelected: identity,
    shouldRenderSuggestions: value => value.trim().length > 0,
    filterSuggestions: identity,
    getSuggestionValue: suggestion => suggestion.name,
    renderSuggestion: suggestion => suggestion.name,
  };

  onInputChange = (e, { newValue }) => {
    this.setState({ query: newValue });
  };

  onSuggestionFetchRequested = ({ value }) => {
    const req = request.get(this.props.url, { [this.props.queryParam]: value });
    this.setState({ currentRequest: req });
    req.then(response => {
      const rawSuggestions = this.props.mapResponseToSuggestions(response);
      const suggestions = this.props.filterSuggestions(rawSuggestions);
      this.setState({ suggestions, currentRequest: null });
    });
  };

  onSuggestionsClearRequested = () => {
    // If a request is taking a long time and the user types more content,
    // we don't want to accidentally set the old request as the new suggestions
    // We can abort the request here, which won't allow it to complete in onSuggestionsFetchRequested
    if (this.state.currentRequest) {
      this.state.currentRequest.abort();
    }
    this.setState({ suggestions: [], currentRequest: null });
  };

  onSuggestionSelected = (e, { suggestion }) => {
    this.props.onSuggestionSelected(suggestion);
    this.setState({ query: '' });
  };

  render() {
    return (
      <div className={`${this.props.icon ? 'NewInput-wrapper--withIcon' : ''}`}>
        <AutoSuggest
          suggestions={this.state.suggestions}
          renderSuggestion={this.props.renderSuggestion}
          getSuggestionValue={this.props.getSuggestionValue}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionSelected={this.onSuggestionSelected}
          onSuggestionsFetchRequested={this.onDebouncedFetchRequested}
          shouldRenderSuggestions={this.props.shouldRenderSuggestions}
          className="w-fill"
          inputProps={{
            placeholder: this.props.placeholder,
            onChange: this.onInputChange,
            value: this.state.query,
            disabled: this.props.disabled,
            ...(this.props.className && { className: this.props.className }),
          }}
        />

        {this.props.icon && this.state.query.length < 1 && (
          <Icon name={this.props.icon} />
        )}
      </div>
    );
  }
}

export default RemoteAutoComplete;
